import { gql } from '@apollo/client'

export const GET_ORIGINATIONS = gql`
  query {
    originations: getOriginationsAdmin
  }
`
